import { useMutation } from "@tanstack/react-query";
import { createCoachingNote, ApiError } from "@/lib/api";
import { isCurrentDraftContext, useComposerDraftContext } from "@/features/coach-review/composerDrafts";
import { invalidateScope } from "@/lib/queryClient";
import type { CoachingNote, CreateCoachingNoteRequest } from "@/lib/types";

export function useQuickFeedback() {
  const context = useComposerDraftContext();
  return useMutation<
    { note: CoachingNote },
    ApiError,
    CreateCoachingNoteRequest
  >({
    meta: { composerContext: context },
    mutationFn: (body) => {
      if (!context || !isCurrentDraftContext(context)) {
        throw new ApiError(409, "Composer context changed. Reopen your feedback before saving.");
      }
      return createCoachingNote(body, { teamId: context.teamId, seasonId: context.seasonId });
    },
    onSuccess: () => isCurrentDraftContext(context) ? invalidateScope() : undefined,
  });
}
